export enum HeroHeight {
	FullSize = 'Full Size',
	AutomaticHeight = 'Automatic Height',
}
